import * as Sentry from '@sentry/react';
import { addBreadcrumb, warn, error, httpError, log } from './sentry-logger';

export const sentry: {
  instance: typeof Sentry;
  init: (config: Sentry.BrowserOptions) => ReturnType<typeof Sentry.init>;
  log: typeof log;
  warn: typeof warn;
  error: typeof error;
  httpError: typeof httpError;
  addBreadcrumb: typeof addBreadcrumb;
} = {
  instance: Sentry,
  init: (config: Sentry.BrowserOptions) => Sentry.init(config),
  log,
  warn,
  error,
  httpError,
  addBreadcrumb,
};

// expose sentry as global so it can be accessed in index.html
(globalThis as any).sentry = sentry;
